import DesignSystemPanel from './components/DesignSystemPanel';
import { useDesignSystem } from './useDesignSystem';
import { DesignSystemSkeleton } from './components/DesignSystemSkeleton';

/**
 * Design System feature module: brand colors, typography, and logo for the
 * startup's primary project, applied across every scope under it.
 */
export function DesignSystemModule(): JSX.Element {
  const { primaryProjectId } = useDesignSystem();

  return (
    <section className="flex h-[calc(100dvh-4rem)] w-full flex-col overflow-hidden">
      {!primaryProjectId ? (
        <DesignSystemSkeleton />
      ) : (
        <DesignSystemPanel projectId={primaryProjectId} layout="page" />
      )}
    </section>
  );
}
